import { OptionDto } from "@/dtos";

const accessFilters = [
    { value: 1, label: 'Activo', tooltip: 'Visualizar los datos de accesos al sistema en tiempo real' },
    { value: 2, label: 'Histórico', tooltip: 'Visualizar los datos pasados de acceso al sistema por mes' }
] as OptionDto[];

export const getAccessFilters = (): OptionDto[] => {
    return accessFilters;
}